/*!

=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import ReactDOM from 'react-dom';
import { UserProvider } from './context/UserContext';

import App from './app.js';

import 'assets/scss/material-dashboard-pro-react.scss?v=1.9.0';
import 'src/themes/reactDatetime.css';

import store from '../src/app/store';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/styles';
import defaultTheme from '@themes/defaultTheme';
import ErrorBoundary from '@hoc/ErrorBoundary';
import { StyledEngineProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={defaultTheme}>
          <ErrorBoundary>
            <Provider store={store}>
              <App />
            </Provider>
          </ErrorBoundary>
        </ThemeProvider>
      </StyledEngineProvider>
      <ToastContainer />
    </UserProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
